import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RouterInitState } from '../../api/core';
import { Router } from '../devices.models';

@Component({
    selector: 'liebherr-certificate-state',
    templateUrl: 'certificate-state.component.html',
    styleUrls: ['certificate-state.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CertificateStateComponent {
    @Input() device?: Router;

    ROUTER_STATE = RouterInitState;

    certificateTooltipItems = ['requestTime', 'grantedTime', 'validityPeriod', 'grantedBy', 'fetchedTime'];
}
